module.exports = __webpack_public_path__ + "img/area display tv.a6125473.jpg";